export const parseEntityItemId = (entityItemId, numOfUnderscores) => {
  if (entityItemId === '') {
    return {
      entities: [],
      itemId: ''
    };
  }
  const parts = entityItemId.split('_');
  const entities = parts.slice(0, numOfUnderscores);
  const itemIdParts = parts.slice(numOfUnderscores);
  const itemId = itemIdParts.join('_');
  return {
    entities,
    itemId
  };
};
//# sourceMappingURL=parse-entity-item-id.js.map